import { render, staticRenderFns } from "./PersonEdit.vue?vue&type=template&id=10f2bfb6&scoped=true&"
import script from "./PersonEdit.vue?vue&type=script&lang=js&"
export * from "./PersonEdit.vue?vue&type=script&lang=js&"
import style0 from "./PersonEdit.vue?vue&type=style&index=0&id=10f2bfb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f2bfb6",
  null
  
)

export default component.exports